import { render, staticRenderFns } from "./BaseRadioButton.vue?vue&type=template&id=16dc5e0b&scoped=true"
import script from "./BaseRadioButton.vue?vue&type=script&lang=js"
export * from "./BaseRadioButton.vue?vue&type=script&lang=js"
import style0 from "./BaseRadioButton.vue?vue&type=style&index=0&id=16dc5e0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dc5e0b",
  null
  
)

export default component.exports